import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {CommonModule} from '@angular/common';
import {
    NGX_MAT_DATE_FORMATS, NgxMatDateFormats,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule
} from '@angular-material-components/datetime-picker';
import {DateTimePickerComponent} from './date-time-picker.component';
import {NgxMatMomentModule} from '@angular-material-components/moment-adapter';
import {MatIconModule} from '@angular/material/icon';

const CUSTOM_DATE_FORMATS: NgxMatDateFormats = {
    parse: {
        dateInput: 'YYYY-MM-DD HH:mm:ss'
    },
    display: {
        dateInput: 'YYYY-MM-DD HH:mm:ss',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY'
    }
};

@NgModule({
    declarations: [
        DateTimePickerComponent
    ],
    imports: [
        CommonModule,
        MatDatepickerModule,
        MatInputModule,
        NgxMatTimepickerModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        NgxMatDatetimePickerModule,
        NgxMatMomentModule,
        MatIconModule
    ],
    providers: [
        MatDatepickerModule,
        {
            provide: NGX_MAT_DATE_FORMATS,
            useValue: CUSTOM_DATE_FORMATS
        }
    ],
    exports: [
        DateTimePickerComponent
    ]
})
export class DateTimePickerModule {
}
